import React from 'react';
import './Index.css';

const Privacy = (props) => {
  return (
    <div className='main'>
      <br/>
      <br/>
      <h1 className='terms-heading'>
        Privacy Policy
      </h1> <br/>

      <h6 className='terms-heading'>
        Last updated: April 17, 2023
      </h6> <br/>


      <h4 className='terms-heading'>
      PLEASE READ THIS POLICY CAREFULLY BEFORE USING THE WIZWACK PLATFORM
      </h4> <br/>


      <p1 className='terms-text'>
      We, at WizWack Studios Private Limited (WizWack, We, us, our) respect the privacy of our users (Users, you, your) and we want you to be informed of our practices, when we collect, process, use and disclose information. This Privacy Policy (Policy) governs our data collection, processing, transfer protocols, to enable you to better understand the manner in which we handle your personal information (as defined by law). This Privacy Policy covers only information collected through our Platform and does not cover any other data collection or processing, without limitation, collection conducted offline, or through our products or services that do not link directly with this Policy, or by third-party sites that we may link to.
      </p1><br/><br/>
      <p1 className='terms-text'>
      By accessing, downloading, and/or using the Platform, you agree to be governed by the terms of this Policy. This Policy shall be read in conjunction with the Terms of Use https://www.wizwack.in/tnc, which shall form a binding agreement with you.
      </p1><br/><br/>
      <p1 className='terms-text'>
      We may revise this Policy, and update our Services and the Platform from time to time. So, we request you to please review this page regularly and take notice of any changes we make. We will, in any event, periodically inform our users of this Policy, and any change in this Policy, as required by law. If you do not agree with any part of this Policy, please stop using our Services or accessing this Platform immediately.
      </p1><br/><br/>
      <p1 className='terms-text'>
      Capitalized words used in this Policy and not defined will have the meaning given to such words in the Terms of Use.
      </p1><br/><br/><br/>


      <br/>
      <h5 className='terms-heading'>
      What Data Do We Collect?
      </h5> <br/>
      <p1 className='terms-text'>
      When you visit our website, use our mobile application, and our Services, you trust us with your personal information. We take your privacy seriously. Through this policy, we have tried to explain to you in the clearest and simplest way possible what information we collect, why we collect it, by what means, and how we use it. We collect this information to ensure that we can provide you our Services in the best manner possible. And we wish to keep such collection and usage of data as transparent as possible.
      </p1><br/><br/>
      <p1 className='terms-text'>
      Below is the the list of the data we collect along with its usage
      <ol style={{listStyleType:  'decimal'}}>
      <li className='terms-text'>
        Mobile Number: We mandatorily ask you for your mobile number to be able to verify you, the user, through a One Time Password.
        </li>
        <li className='terms-text'>
        KYC Information: We may ask you to mandatorily submit KYC documents to our licensed service providers, for compliance with applicable laws.
        </li>
        <li className='terms-text'>
        Transaction Information: If you transact on our Platform, i.e., if you add or withdraw money from the Platform to engage in paid gameplay, or otherwise make a purchase on the WizWack Store, we collect transaction information, such as the amount added, withdrawn, or otherwise used to make a purchase; the mode of payment; the date and time of payment; purchase history and corresponding invoice (where required).
        </li>
        <li className='terms-text'>
        Device Data: We collect data about the devices used to access our Services, including the hardware model, device IP address, installed software, available device storage, unique device identifiers, advertising identifiers, and mobile network data, to help identify users and prevent fraud.
        </li>
        <li className='terms-text'>
        Usage Data: We collect data about how you interact with our Services. This includes data such as access date and times, Platform features or pages viewed, Platform crashes and other system activity, type of browser, or third-party sites or services used to interact with our Services, so that we are able to improve users’ experience on the Platform.
        </li>
        <li className='terms-text'>
        Cookies: We collect information through the use of “cookies”, to recognize you and your device, better understand how you navigate through our Services, and improve user experience. You can disable cookies through your web or mobile device through browser settings.
        </li>
        <li className='terms-text'>
        We may receive information about you from third-party websites, if you use social media plug-ins to connect with us. You will be bound by the terms of use, privacy policies of these third parties, and we urge you to review and familiarize yourself with the policies of these websites, before continuously interacting with them.
        </li>
      </ol>
      </p1><br/><br/>


      <br/>
      <h5 className='terms-heading'>
      How And Why Do We Use Collected Data?
      </h5> <br/>
      <p1 className='terms-text'>
      We, and/or third parties who act on our behalf, or provide services to us, may use your data to ensure that our Services are as up to date as possible, and offered in the most optimal manner to you.
      </p1><br/><br/>
      <p1 className='terms-text'>
      Below is the the list of the different usages of the data we collect
      <ol style={{listStyleType:  'decimal'}}>
        <li className='terms-text'>
        We use the data collected to maintain, improve, and personalise our Services. This includes using the data to:
        <ol style={{listStyleType:  'decimal'}}>
        <li className='terms-text'>
          create your profile with us
          </li>
          <li className='terms-text'>
          improve the Services, design and navigation of the Platform
          </li>
          <li className='terms-text'>
          facilitate in-app purchases
          </li>
          <li className='terms-text'>
          provide requested information and support needed to effect transactions on or through our Platform
          </li>
          <li className='terms-text'>
          determine your eligibility to avail WizWack’s Services, and participation in exclusive contests, programs and related offerings; and
          </li>
          <li className='terms-text'>
          perform internal operations that are necessary to provide our Services, such as troubleshooting software bugs, conducting data analysis, detecting fraud, or analysing usage and activity trends on our Platform.
          </li>
        </ol>
        </li>
        <li className='terms-text'>
      We use the data collected to provide customer support and/or resolve your concerns arising from the use of our Services.
      </li>
      <li className='terms-text'>
      We use the data collected for research, analysis, and the development of our Platform to improve the UI/UX, to allow you optimum use of the Platform.
      </li>
      <li className='terms-text'>
      We may use the data collected to promote and market the Platform and our Services.
      </li>
      <li className='terms-text'>
      We may use the data collected to perform our legal or contractual obligations, as otherwise permitted by law, or as and when requested by legal, regulatory, or investigatory authorities.
      </li>
      </ol>
      </p1><br/><br/>


      <br/>
      <h5 className='terms-heading'>
      When And With Whom Do We Share Collected Data?
      </h5> <br/>
      <p1 className='terms-text'>
      We will share your data with third parties only in accordance with this Policy, so that we are able to provide the Services and enable an improved user experience. We have and will never sell your data to third parties for profit.
      </p1><br/><br/>
      <p1 className='terms-text'>
      Below is the the list of the collected data sharage usecases
      <ol style={{listStyleType:  'decimal'}}>
        <li className='terms-text'>
        Service Providers: We work with third-party service providers to perform services on our behalf, such as providing us infrastructural, transactional, maintenance, support, analytics, and marketing and allied services. We only share such data with them, as is necessary for us to provide the Services to you. For matters related to KYC processing, we retain no part or record of your KYC documents, except for an encrypted hash value (i.e., algorithmic code) which has none of your personal information.
        </li>
        <li className='terms-text'>
        Third Party Services: Through the Platform, you may, at your option, be able to connect with other websites, products, or services that we do not control. The use and access of such websites, products or services is subject to their respective privacy policies, and outside our control. We urge you to review and familiarize yourself with their policies before using or accessing them.
        </li>
        <li className='terms-text'>
        Subsidiaries and Affiliates: We may share collected data with subsidiaries, affiliates, or related entities to fulfil a contractual obligation to you.
        </li>
        <li className='terms-text'>
        Change in Control: If we (or our affiliates) are involved in a merger, acquisition and sale of all or substantially all of its assets or equity, we may have to disclose databases stored in the course of our operations.
        </li>
        <li className='terms-text'>
        We may share the data collected as required by applicable law, so as to co-operate with law enforcement agencies or upon receipt of a court order, and/or with courts and public authorities to protect you, us, or third parties from harm, including fraud or instances where somebody’s physical safety may be at risk.
        </li>
      </ol>
      </p1><br/><br/>


      <br/>
      <h5 className='terms-heading'>
      What Are Your Rights Regarding Collected Data?
      </h5> <br/>
      <p1 className='terms-text'>
      We consider it important to empower you with rights regarding your data. And we give you the following rights in this regard:
      <ol style={{listStyleType:  'decimal'}}>
        <li className='terms-text'>
        You may access your information by accessing your account or profile on our Platform.
        </li>
        <li className='terms-text'>
        You may also request corrections, updates, or deletion of your information. We will make reasonable efforts to respond promptly to such requests in accordance with applicable laws. You can reach out to us at the address given in the ‘How Can You Contact Us’ section below.
        </li>
        <li className='terms-text'>
        You may withdraw your consent given to us for processing your data. If you do so, we may be unable to provide the Services for which such data was sought. To withdraw your consent, you may please write us an email at the address given in the ‘How Can You Contact Us’ section below.
        </li>
        <li className='terms-text'>
        If you wish to delete your account maintained with us, you must write to us at the address given in the ‘How Can You Contact Us’ section below. Upon approval of such request, your account will initially stand deactivated for a period of 90 days, within which you may re-activate your account, by accessing your account with your registered details. Alternatively, your account will be deleted and you may not be able to retrieve such information which is purged from WizWack’s systems.
        </li>
      </ol>
      </p1>
      <p1 className='terms-text'>
      Please note that notwithstanding the above rights, we may retain your data for as long as is necessary for the performance of the contract between you and us and to comply with our legal obligations. We will not retain your data if it is no longer required by us and there is no legal requirement to retain the same.
      </p1><br/><br/>


      <br/><br/>
      <h5 className='terms-heading'>
      How Can You Contact Us?
      </h5> <br/>
      <p1 className='terms-text'>
      If you have any questions or want to seek clarifications about this Policy, or any complaints, comments, concerns, or feedback about our Data privacy and protection practices, you may write to us at support[at]wizwack.in
      </p1><br/><br/>


      <br/><br/>
      <h5 className='terms-heading'>
      What Are Our Data Security and Protection Practices?
      </h5> <br/>
      <p1 className='terms-text'>
      We maintain appropriate technical and physical safeguards to protect Information against accidental or unlawful destruction or loss, alteration, unauthorized disclosure or access, and any other unlawful form of processing of the data in our possession. These safeguards ensure a level of protection commensurate to the risk, the nature of our business, and take into account available technologies, implementation costs, the nature, context and purpose of processing, and the degree or likelihood of risk.
      </p1><br/><br/>
      <p1 className='terms-text'>
      However, WizWack does not guarantee that Information will not be accessed, disclosed, altered or destroyed by breach of any of the abovementioned safeguards. WizWack takes all steps reasonably necessary to ensure that Information is treated securely and in accordance with this Policy.
      </p1><br/><br/>
      <p1 className='terms-text'>
      WizWack does not warrant that the Platform, its servers, or any communications shared by us or on our behalf are completely impenetrable from a security standpoint or are virus free. WizWack will not be liable for any damages of any kind arising from the use of the Platform, including, but not limited to any indirect, incidental, special, consequential or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly or any loss of data, use, good-will, or other intangible losses.
      </p1><br/><br/>


      <br/><br/>
      <h5 className='terms-heading'>
      Do We Transfer Data Across Borders?
      </h5> <br/>
      <p1 className='terms-text'>
      We do not store or transfer your data outside India.
      </p1><br/><br/>
      <p1 className='terms-text'>
      We may revise our position, and may transfer your data outside India to territories in which our affiliates or subsidiaries are incorporated in, or work out of; and we will do so upon due notification to you. We will do so only if the destination jurisdiction has an adequate and appropriate level of protection and where the transfer is lawful and necessary for performance of our obligations to you. We will comply with our legal and regulatory obligations in relation to your data, including having a lawful basis for transferring it, and putting appropriate safeguards in place to ensure an adequate level of protection for your data.
      </p1><br/><br/>


      <br/><br/>
      <h5 className='terms-heading'>
      Do We Collect Data From Children?
      </h5> <br/>
      <p1 className='terms-text'>
      Our Services are not directed to persons under legal age of eighteen years. WizWack does not knowingly collect any information from children under legal age. If we are informed that a child under legal age has provided us with their personal information, we will take all the necessary steps to remove such information from our servers and terminate such account. If you become aware that any child has provided personal information, please inform us by writing to us at the address given in the ‘How Can You Contact Us’ section below.
      </p1><br/><br/>


      <br/><br/>
      <h5 className='terms-heading'>
      What If There Are Changes To This Policy?
      </h5> <br/>
      <p1 className='terms-text'>
      WizWack may periodically review and change this Policy to incorporate such changes as may be considered appropriate and will strive to update you of such changes with prior notice, where possible. We urge you to review the Policy on a periodic basis; in the event we make any significant changes to this Policy we will inform you in advance. Your continued use of the Platform and our Services will deem you as having consented to the prevailing Policy.
      </p1><br/><br/>
    </div>
  );
}

export default Privacy